module.exports = __webpack_public_path__ + "img/BelumTumbuh.e743b240.svg";